import { errorToString } from "shared/misc";
import { Ramda } from "../namespaces/Ramda.js";
export const CAMERA_ASPECT_RATIO = 1;
export const CAMERA_CONSTRAINTS = {
    facingMode: {
        exact: "environment",
    },
    width: 2048,
    height: 2048,
    aspectRatio: CAMERA_ASPECT_RATIO
};
export function cameraErrorToString(e) {
    const error = errorToString(e);
    const errorString = "Could not load camera." + (Ramda.isEmpty(error) ? "" : " " + error);
    if (!errorString.endsWith(".")) {
        return errorString + ".";
    }
    return errorString;
}
